module.exports = __webpack_public_path__ + "static/img/glasses.8cacedfd.png";